<template>
    <v-row no-gutters>
        <v-col cols="3" class="pe-1">
            <v-autocomplete
                :prefix="(index + 1) + '#'"
                :label="$t('item')"
                v-model="form.item_id"
                :rules="[isRequired]"
                outlined
                dense
                hide-details
                :items="items"
                item-text="display_name"
                item-value="id"
                @update:search-input="$emit('update:item-search-input', $event)"
                @change="onItemChange"
                clearable>
            </v-autocomplete>
        </v-col>
        <v-col cols="1" class="pe-1">
            <v-autocomplete
                :label="$t('measure_unit')"
                v-model="form.measure_unit_id"
                :rules="[isRequired]"
                item-text="abbreviation"
                item-value="id"
                :items="measureUnits"
                outlined
                dense
                hide-details>
            </v-autocomplete>
        </v-col>
        <v-col cols="1" class="pe-1">
            <v-text-field
                :label="$t('available_quantity')"
                :value="form.available_quantity"
                :loading="avaliableQuantityLoading"
                outlined
                disabled
                dense
                hide-details
                >
            </v-text-field>
        </v-col>
        <v-col cols="1" class="pe-1">
            <v-text-field
                :label="$t('quantity')"
                v-model="form.quantity"
                :rules="[isRequired, isNumeric]"
                outlined
                dense
                hide-details>
            </v-text-field>
        </v-col>
        <v-col cols="2" class="pe-1">
            <v-text-field
                :label="$t('unit_value')"
                :value="form.unit_value"
                :loading="unitValueLoading"
                :rules="[isRequired]"
                outlined
                disabled
                dense
                hide-details
                >
            </v-text-field>
        </v-col>
        <v-col cols="2" class="pe-1">
            <v-autocomplete
                :label="$t('account')"
                v-model="form.account_id"
                :rules="[isRequired]"
                outlined
                dense
                hide-details
                :items="accounts"
                item-text="display_name"
                item-value="id"
                @update:search-input="$emit('update:account-search-input', $event)">
            </v-autocomplete>
        </v-col>
        <v-col cols="2" class="d-flex flex-row align-center">
            <v-autocomplete
                :label="$t('dimension')"
                v-model="form.dimension_id"
                outlined
                dense
                :items="dimensions"
                :rules="[isRequired]"
                item-text="name"
                item-value="id"
                hide-details
                @update:search-input="$emit('update:dimension-search-input', $event)">
            </v-autocomplete>
            <v-btn icon @click="$emit('delete:line')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric } from './../../utils/validations';
import { getItemUnitValue, getAvailableQuantity } from './../../services/stock/item'
import { round } from 'lodash';

export default {
    props: {
        items: Array,
        documentDate: String,
        accounts: Array,
        dimensions: Array,
        value: Object,
        warehouseId: [Number, String],
        index: [Number, String]
    },
    data() {
        return {
            form: {
                item_id: null,
                quantity: null,
                base_quantity: null,
                measure_unit_id: null,
                unit_value: null,
                value: null,
                account_id: null,
                dimension_id: null,
                available_quantity: 5
            },
            unitValueLoading: false,
            avaliableQuantityLoading: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form, value: this.totalValue});
            }
        },
        "form.item_id": {
            handler() {
                // reset unit value and do nothing
                if(!this.form.item_id || !this.form.measure_unit_id || !this.warehouseId || !this.documentDate) {
                    this.form.unit_value = 0;
                    this.form.available_quantity = 0;
                    return;
                }

                if(this.inEditMode) {
                    return;
                }

                // otherwise fetch the item unit value
                this.fetchUnitValueAsync();
                this.fetchAvailableQuantity();
            }
        },
        "form.measure_unit_id": {
            handler() {
                // reset unit value and do nothing
                if(!this.form.item_id || !this.form.measure_unit_id || !this.warehouseId || !this.documentDate) {
                    this.form.unit_value = 0;
                    this.form.available_quantity = 0;
                    return;
                }

                if(this.inEditMode) {
                    return;
                }

                // otherwise fetch the item unit value
                this.fetchUnitValueAsync();
                this.fetchAvailableQuantity();
            }
        }
    },
    computed: {
        item() {
            return this.items.find(each => each.id == this.form.item_id)
        },
        measureUnits() {
            if(!this.item) return [];
            if(!Array.isArray(this.item.measure_units)) return [];
            return this.item.measure_units;
        },
        totalValue() {
            return this.form.unit_value * this.form.quantity;
        },
        inEditMode() {
            return !!this.form.id;
        }
    },
    methods: {
        isRequired, isNumeric,
        fetchUnitValueAsync() {
            this.unitValueLoading = true;
            getItemUnitValue(this.form.item_id, this.warehouseId, this.form.measure_unit_id, this.documentDate).then(response => {
                this.form.unit_value = round(response.data.value, 2)
            }).catch(() => {
                this.form.unit_value = 0;
            }).finally(() => {
                this.unitValueLoading = false;
            })
        },
        fetchAvailableQuantity() {
            this.avaliableQuantityLoading = true;
            getAvailableQuantity(this.form.item_id, this.warehouseId, this.form.measure_unit_id, this.documentDate).then(response => {
                this.form.available_quantity = round(response.data.value, 2)
            }).catch(() => {
                this.form.available_quantity = 0;
            }).finally(() => {
                this.avaliableQuantityLoading = false;
            })
        },
        onItemChange() {
            this.form.measure_unit_id = null;
        }
    },
    created() {
        if(this.value) {
            this.form = {...this.value}
        }
    }
}
</script>

<style>

</style>